import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE =
  "حاسبة شحنة الأيون - حساب شحنة الأيونات للعناصر الكيميائية بدقة وسهولة";
const DESCRIPTION =
  "استخدم حاسبة شحنة الأيون المتقدمة لحساب شحنة الأيون لأي عنصر كيميائي بدقة. توفر هذه الأداة تعليمات واضحة وخطوات مفصلة لمساعدتك في فهم كيفية حساب شحنة الأيونات بسهولة. مثالية للطلاب، الباحثين، ومحترفي الكيمياء الذين يحتاجون إلى حسابات دقيقة وسريعة لشحنات الأيونات.";
const KEYWORDS =
  "حاسبة شحنة الأيون, حساب شحنة الأيونات, شحنة الأيونات, حساب الشحنات الكيميائية, أدوات حساب الأيونات, الكيمياء, شحنات الأيونات, حساب شحنة الأيونات للعناصر الكيميائية";
const OG_URL = "https://do-calculate.com/calculator/ar/ion-charge-calculator/";
const elements = [
  { symbol: "H", name: "هيدروجين", protons: 1 },
  { symbol: "He", name: "هيليوم", protons: 2 },
  { symbol: "Li", name: "ليثيوم", protons: 3 },
  { symbol: "Be", name: "بيريليوم", protons: 4 },
  { symbol: "B", name: "بورون", protons: 5 },
  { symbol: "C", name: "كربون", protons: 6 },
  { symbol: "N", name: "نيتروجين", protons: 7 },
  { symbol: "O", name: "أكسجين", protons: 8 },
  { symbol: "F", name: "فلور", protons: 9 },
  { symbol: "Ne", name: "نيون", protons: 10 },
  { symbol: "Na", name: "صوديوم", protons: 11 },
  { symbol: "Mg", name: "مغنيسيوم", protons: 12 },
  { symbol: "Al", name: "ألومنيوم", protons: 13 },
  { symbol: "Si", name: "سيليكون", protons: 14 },
  { symbol: "P", name: "فوسفور", protons: 15 },
  { symbol: "S", name: "كبريت", protons: 16 },
  { symbol: "Cl", name: "كلور", protons: 17 },
  { symbol: "Ar", name: "أرجون", protons: 18 },
  { symbol: "K", name: "بوتاسيوم", protons: 19 },
  { symbol: "Ca", name: "كالسيوم", protons: 20 },
  { symbol: "Sc", name: "سكانديوم", protons: 21 },
  { symbol: "Ti", name: "تيتانيوم", protons: 22 },
  { symbol: "V", name: "فاناديوم", protons: 23 },
  { symbol: "Cr", name: "كروم", protons: 24 },
  { symbol: "Mn", name: "منغنيز", protons: 25 },
  { symbol: "Fe", name: "حديد", protons: 26 },
  { symbol: "Co", name: "كوبالت", protons: 27 },
  { symbol: "Ni", name: "نيكل", protons: 28 },
  { symbol: "Cu", name: "نحاس", protons: 29 },
  { symbol: "Zn", name: "زنك", protons: 30 },
  { symbol: "Ga", name: "جاليوم", protons: 31 },
  { symbol: "Ge", name: "جرمانيوم", protons: 32 },
  { symbol: "As", name: "زرنيخ", protons: 33 },
  { symbol: "Se", name: "سيلينيوم", protons: 34 },
  { symbol: "Br", name: "بروم", protons: 35 },
  { symbol: "Kr", name: "كريبتون", protons: 36 },
  { symbol: "Rb", name: "روبيديوم", protons: 37 },
  { symbol: "Sr", name: "سترونشيوم", protons: 38 },
  { symbol: "Y", name: "إتريوم", protons: 39 },
  { symbol: "Zr", name: "زركونيوم", protons: 40 },
  { symbol: "Nb", name: "نيوبيوم", protons: 41 },
  { symbol: "Mo", name: "موليبدينوم", protons: 42 },
  { symbol: "Tc", name: "تكنيتيوم", protons: 43 },
  { symbol: "Ru", name: "روثينيوم", protons: 44 },
  { symbol: "Rh", name: "روديوم", protons: 45 },
  { symbol: "Pd", name: "بالاديوم", protons: 46 },
  { symbol: "Ag", name: "فضة", protons: 47 },
  { symbol: "Cd", name: "كادميوم", protons: 48 },
  { symbol: "In", name: "إنديوم", protons: 49 },
  { symbol: "Sn", name: "قصدير", protons: 50 },
  { symbol: "Sb", name: "أنتيمون", protons: 51 },
  { symbol: "Te", name: "تيلوريوم", protons: 52 },
  { symbol: "I", name: "يود", protons: 53 },
  { symbol: "Xe", name: "زينون", protons: 54 },
  { symbol: "Cs", name: "سيزيوم", protons: 55 },
  { symbol: "Ba", name: "باريوم", protons: 56 },
  { symbol: "La", name: "لانثانوم", protons: 57 },
  { symbol: "Ce", name: "سيريوم", protons: 58 },
  { symbol: "Pr", name: "برازوديميوم", protons: 59 },
  { symbol: "Nd", name: "نيوديميوم", protons: 60 },
  { symbol: "Pm", name: "بروميثيوم", protons: 61 },
  { symbol: "Sm", name: "ساماريوم", protons: 62 },
  { symbol: "Eu", name: "يوروبيوم", protons: 63 },
  { symbol: "Gd", name: "جادولينيوم", protons: 64 },
  { symbol: "Tb", name: "تيربيوم", protons: 65 },
  { symbol: "Dy", name: "ديسبروسيوم", protons: 66 },
  { symbol: "Ho", name: "هولميوم", protons: 67 },
  { symbol: "Er", name: "إربيوم", protons: 68 },
  { symbol: "Tm", name: "ثوليوم", protons: 69 },
  { symbol: "Yb", name: "إتيربيوم", protons: 70 },
  { symbol: "Lu", name: "لوتيتيوم", protons: 71 },
  { symbol: "Hf", name: "هافنيوم", protons: 72 },
  { symbol: "Ta", name: "تانتالوم", protons: 73 },
  { symbol: "W", name: "تنجستن", protons: 74 },
  { symbol: "Re", name: "رينيوم", protons: 75 },
  { symbol: "Os", name: "أوزميوم", protons: 76 },
  { symbol: "Ir", name: "إيريديوم", protons: 77 },
  { symbol: "Pt", name: "بلاتين", protons: 78 },
  { symbol: "Au", name: "ذهب", protons: 79 },
  { symbol: "Hg", name: "زئبق", protons: 80 },
  { symbol: "Tl", name: "ثاليوم", protons: 81 },
  { symbol: "Pb", name: "رصاص", protons: 82 },
  { symbol: "Bi", name: "بزموت", protons: 83 },
  { symbol: "Po", name: "بولونيوم", protons: 84 },
  { symbol: "At", name: "أستاتين", protons: 85 },
  { symbol: "Rn", name: "رادون", protons: 86 },
  { symbol: "Fr", name: "فرانسيوم", protons: 87 },
  { symbol: "Ra", name: "راديوم", protons: 88 },
  { symbol: "Ac", name: "أكتينيوم", protons: 89 },
  { symbol: "Th", name: "ثوريوم", protons: 90 },
  { symbol: "Pa", name: "بروتكتينيوم", protons: 91 },
  { symbol: "U", name: "يورانيوم", protons: 92 },
  { symbol: "Np", name: "نبتونيوم", protons: 93 },
  { symbol: "Pu", name: "بلوتونيوم", protons: 94 },
  { symbol: "Am", name: "أمريسيوم", protons: 95 },
  { symbol: "Cm", name: "كوريم", protons: 96 },
  { symbol: "Bk", name: "بيركيليوم", protons: 97 },
  { symbol: "Cf", name: "كاليفورنيوم", protons: 98 },
  { symbol: "Es", name: "أينشتاينيوم", protons: 99 },
  { symbol: "Fm", name: "فيرميوم", protons: 100 },
  { symbol: "Md", name: "مندليفيوم", protons: 101 },
  { symbol: "No", name: "نوبليوم", protons: 102 },
  { symbol: "Lr", name: "لورنسيوم", protons: 103 },
  { symbol: "Rf", name: "راذرفورديوم", protons: 104 },
  { symbol: "Db", name: "دبنيوم", protons: 105 },
  { symbol: "Sg", name: "سيبورغيوم", protons: 106 },
  { symbol: "Bh", name: "بوريوم", protons: 107 },
  { symbol: "Hs", name: "هاسيوم", protons: 108 },
  { symbol: "Mt", name: "مايتنريوم", protons: 109 },
  { symbol: "Ds", name: "دارمشتاتيوم", protons: 110 },
  { symbol: "Rg", name: "رونتجينيوم", protons: 111 },
  { symbol: "Cn", name: "كوبرنيسيوم", protons: 112 },
  { symbol: "Nh", name: "نيهونيوم", protons: 113 },
  { symbol: "Fl", name: "فليروفيوم", protons: 114 },
  { symbol: "Mc", name: "موسكوفيوم", protons: 115 },
  { symbol: "Lv", name: "ليفرموريوم", protons: 116 },
  { symbol: "Ts", name: "تينيسين", protons: 117 },
  { symbol: "Og", name: "أوغانيسون", protons: 118 },
];
function Calculator() {
  const [compound, setCompound] = useState([{ element: "", electrons: "" }]);
  const [ionCharge, setIonCharge] = useState("");
  const [explanation, setExplanation] = useState("");
  const [error, setError] = useState("");
  const handleAddElement = () => {
    setCompound([...compound, { element: "", electrons: "" }]);
  };
  const handleElementChange = (index, value) => {
    const newCompound = [...compound];
    newCompound[index].element = value;
    setCompound(newCompound);
  };
  const handleElectronsChange = (index, value) => {
    const newCompound = [...compound];
    newCompound[index].electrons = value;
    setCompound(newCompound);
  };
  const handleCalculate = () => {
    let totalIonCharge = 0;
    let explanationSteps = "";
    for (const { element, electrons } of compound) {
      if (!element || electrons === "") {
        setError("الرجاء إدخال جميع العناصر وعدد الإلكترونات بشكل صحيح");
        setIonCharge("");
        setExplanation("");
        return;
      }
      const elementData = elements.find((e) => e.symbol === element);
      if (!elementData) {
        setError("عنصر غير صالح. الرجاء اختيار عنصر صحيح.");
        setIonCharge("");
        setExplanation("");
        return;
      }
      const ionChargeValue = elementData.protons - parseInt(electrons);
      totalIonCharge += ionChargeValue;
      explanationSteps += `${
        elementData.protons
      } (عدد البروتونات) - ${electrons} (عدد الإلكترونات) = ${
        ionChargeValue > 0 ? "+" : ""
      }${ionChargeValue} شحنة الأيون لـ${elementData.name}\n`;
    }
    setIonCharge(`${totalIonCharge > 0 ? "+" : ""}${totalIonCharge}`);
    setExplanation(explanationSteps);
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  شحنة الأيون هي الشحنة الكهربائية التي يحملها عنصر كيميائي
                  نتيجة لاكتسابه أو فقدانه للإلكترونات. تُحدد شحنة الأيون من
                  خلال الفرق بين عدد البروتونات والإلكترونات في الذرة. لحساب
                  شحنة الأيون بدقة، يتم خصم عدد الإلكترونات من عدد البروتونات في
                  العنصر.
                </p>
                <p>
                  باستخدام حاسبة شحنة الأيون المتقدمة لدينا، يمكنك حساب شحنة
                  الأيون لأي عنصر كيميائي بسرعة وسهولة. تقوم هذه الحاسبة بحساب
                  شحنة الأيون بشكل تلقائي استناداً إلى البيانات المدخلة، مما
                  يوفر لك نتائج دقيقة وموثوقة.
                </p>
                <p>إليك مثال توضيحي لحساب شحنة الأيون:</p>
                <ul>
                  <li>
                    <strong>عدد البروتونات في الصوديوم (Na)</strong>: 11
                  </li>
                  <li>
                    <strong>عدد الإلكترونات بعد فقد إلكترون واحد</strong>: 10
                  </li>
                  <li>
                    <strong>شحنة الأيون للصوديوم</strong>: 11 - 10 = +1
                  </li>
                </ul>
                <p>
                  باستخدام حاسبتنا، يمكنك إدخال عدد البروتونات والإلكترونات،
                  وستقوم الأداة بحساب الشحنة وتقديمها لك بشكل فوري. الأداة
                  مثالية للطلاب، والباحثين، والعلماء الذين يحتاجون إلى حسابات
                  دقيقة وسريعة في مجال الكيمياء.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  {compound.map((item, index) => (
                    <div
                      key={index}
                      className="form-group d-flex align-items-center"
                    >
                      <b>
                        <label className="form-label ms-2">
                          العنصر {index + 1}
                        </label>
                      </b>
                      <select
                        value={item.element}
                        onChange={(e) =>
                          handleElementChange(index, e.target.value)
                        }
                        className="form-control"
                        style={{ width: "150px", marginRight: "10px" }}
                      >
                        <option value="">اختر العنصر</option>
                        {elements.map((el) => (
                          <option key={el.symbol} value={el.symbol}>
                            {el.name} ({el.symbol})
                          </option>
                        ))}
                      </select>
                      <input
                        type="number"
                        min="0"
                        placeholder="عدد الإلكترونات"
                        value={item.electrons}
                        onChange={(e) =>
                          handleElectronsChange(index, e.target.value)
                        }
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                  ))}
                  <br />
                  <button
                    className="btn btn-success"
                    onClick={handleAddElement}
                  >
                    إضافة عنصر آخر
                  </button>
                  <br/>                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculate}
                  >
                    احسب                  </button>
                </div>
                <br />
                <div>
                  { error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      خطأ: {error}
                    </p>
                  ) : (
                    <>
                      { ionCharge !== "" && (
                        <>
                          <p className="p-3 mb-2 bg-success text-white">
                            شحنة الأيون: {ionCharge}
                          </p>
                          {explanation !== "" && (
                            <p className="p-3 mb-2 bg-info text-black">
                              خطوات الحساب: <br />
                              {explanation.split("\n").map((line, index) => (
                                <React.Fragment key={index}>
                                  {line}
                                  <br />
                                </React.Fragment>
                              ))}
                            </p>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
